// import React, { useEffect, useState } from 'react';
// import {
//   Box, Typography, Button, Dialog, DialogActions,
//   DialogContent, DialogTitle, TextField, IconButton,
// } from '@mui/material';
// import { Delete, Edit } from '@mui/icons-material';
// import TableComponent from '../../Components/TableComponent/TableComponent';
// import { SnackBarComponent } from '../../Components/snackBar/snackBar';
// import { LoadingSpinner } from '../../Components/spinner/spinner';
// import { API_BASE_URL } from '../../config';
// import api from '../../api/axiosInterceptor';
// import axios from 'axios';

// export const AdminCalendarEvents = () => {
//   const [rows, setRows] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState('');
//   const [snackbarSeverity, setSnackbarSeverity] = useState('info');

//   const [openFormDialog, setOpenFormDialog] = useState(false);
//   const [isEditMode, setIsEditMode] = useState(false);
//   const [selectedEvent, setSelectedEvent] = useState(null);

//   const [formData, setFormData] = useState({
//     event_name: '',
//     start_date: '',
//     end_date: '',
//     link: '',
//   });

//   const [formErrors, setFormErrors] = useState({});
//   const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
//   const [deleteEvent, setDeleteEvent] = useState(null);

//   const columns = [
//     { id: 'slNo', field: 'slNo', headerName: 'Sl No.', width: 70 },
//     { id: 'eventName', field: 'eventName', headerName: 'Event Name', width: 100 },
//     { id: 'startDate', field: 'startDate', headerName: 'Start Time', width: 100 },
//     { id: 'endDate', field: 'endDate', headerName: 'End Time', width: 100 },
//     {
//       id: 'detailsLink',
//       field: 'detailsLink',
//       headerName: 'Details',
//       width: 120,
//       renderCell: (params) => (
//         <a href={params.value} target="_blank" rel="noopener noreferrer">
//           View Details
//         </a>
//       ),
//     },
//     {
//       id: 'actions',
//       field: 'actions',
//       headerName: 'Actions',
//       width: 150,
//       renderCell: (params) => (
//         <>
//           <IconButton color="primary" onClick={() => handleEdit(params.row)}>
//             <Edit />
//           </IconButton>
//           <IconButton color="error" onClick={() => handleDeleteConfirmation(params.row)}>
//             <Delete />
//           </IconButton>
//         </>
//       ),
//     },
//   ];

//   useEffect(() => {
//     fetchEvents();
//   }, []);

//   const fetchEvents = () => {
//     setLoading(true);
//     axios.get(`${API_BASE_URL}/home-notification/calender-event/`)
//       .then(response => {
//         const apiData = response.data.map((item, index) => ({
//           id: item.id,
//           slNo: index + 1,
//           eventName: item.event_name,
//           startDate: item.start_date,
//           endDate: item.end_date,
//           detailsLink: item.link,
//         }));
//         setRows(apiData);
//         setLoading(false);
//       })
//       .catch(error => {
//         console.error('Failed to fetch calendar events:', error);
//         setSnackbarMessage('Failed to load calendar events.');
//         setSnackbarSeverity('error');
//         setSnackbarOpen(true);
//         setLoading(false);
//       });
//   };

//   const handleSnackbarClose = () => setSnackbarOpen(false);

//   const handleAddEvent = () => {
//     setIsEditMode(false);
//     setFormData({ event_name: '', start_date: '', end_date: '', link: '' });
//     setFormErrors({});
//     setOpenFormDialog(true);
//   };

//   const handleEdit = (event) => {
//     setIsEditMode(true);
//     setSelectedEvent(event);
//     setFormData({
//       event_name: event.eventName,
//       start_date: event.startDate,
//       end_date: event.endDate,
//       link: event.detailsLink,
//     });
//     setFormErrors({});
//     setOpenFormDialog(true);
//   };

//   const handleDeleteConfirmation = (event) => {
//     setDeleteEvent(event);
//     setDeleteDialogOpen(true);
//   };

//   const handleDelete = () => {
//     api.delete(`${API_BASE_URL}/home-notification/calender-event/${deleteEvent.id}/`)
//       .then(() => {
//         setSnackbarMessage('Calendar event deleted successfully.');
//         setSnackbarSeverity('success');
//         setSnackbarOpen(true);
//         fetchEvents();
//       })
//       .catch(error => {
//         console.error('Delete failed:', error);
//         setSnackbarMessage('Failed to delete calendar event.');
//         setSnackbarSeverity('error');
//         setSnackbarOpen(true);
//       })
//       .finally(() => {
//         setDeleteDialogOpen(false);
//         setDeleteEvent(null);
//       });
//   };

//   const validateForm = () => {
//     const errors = {};
//     if (!formData.event_name?.trim()) errors.event_name = 'Event name is required';
//     if (!formData.start_date) errors.start_date = 'Start date is required';
//     if (!formData.end_date) errors.end_date = 'End date is required';
//     if (!formData.link?.trim()) errors.link = 'Details link is required';
//     else if (!/^https?:\/\/.+\..+/.test(formData.link)) errors.link = 'Invalid link format';
//     setFormErrors(errors);
//     return Object.keys(errors).length === 0;
//   };

//   const handleFormSubmit = () => {
//     if (!validateForm()) return;
//     if (isEditMode) {
//       api.patch(`${API_BASE_URL}/home-notification/calender-event/${selectedEvent.id}/`, formData)
//         .then(() => {
//           setSnackbarMessage('Calendar event updated successfully.');
//           setSnackbarSeverity('success');
//           setSnackbarOpen(true);
//           fetchEvents();
//         })
//         .catch(error => {
//           console.error('Update failed:', error);
//           setSnackbarMessage('Failed to update calendar event.');
//           setSnackbarSeverity('error');
//           setSnackbarOpen(true);
//         })
//         .finally(() => setOpenFormDialog(false));
//     } else {
//       api.post(`${API_BASE_URL}/home-notification/calender-event/`, formData)
//         .then(() => {
//           setSnackbarMessage('Calendar event added successfully.');
//           setSnackbarSeverity('success');
//           setSnackbarOpen(true);
//           fetchEvents();
//         })
//         .catch(error => {
//           console.error('Add failed:', error);
//           setSnackbarMessage('Failed to add calendar event.');
//           setSnackbarSeverity('error');
//           setSnackbarOpen(true);
//         })
//         .finally(() => setOpenFormDialog(false));
//     }
//   };

//   if (loading) {
//     return <LoadingSpinner size={30} />;
//   }

//   return (
//     <Box sx={{ width: '100%', mt: 8, mb: 1, borderRadius: 2, boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)', backgroundColor: '#fff' }}>
//       <Box display="flex" justifyContent="space-between" alignItems="center" backgroundColor="rgba(195, 234, 203, 0.1)" p={2}>
//         <Typography variant="h4" component="h1" sx={{ fontWeight: 'bold' }}>
//           Admin Calendar Events
//         </Typography>
//         <Button variant="contained" color="primary" onClick={handleAddEvent}>
//           Add Event
//         </Button>
//       </Box>

//       <TableComponent
//         columns={columns}
//         rows={rows}
//         manageColumnStatus
//         enableSort={true}
//         sx={{
//           '& .MuiDataGrid-columnHeaders': {
//             backgroundColor: '#1976d2',
//             color: '#fff',
//             fontWeight: 'bold',
//           },
//         }}
//       />

//       <Dialog open={openFormDialog} onClose={() => setOpenFormDialog(false)}>
//         <DialogTitle>{isEditMode ? 'Edit Event' : 'Add Event'}</DialogTitle>
//         <DialogContent>
//           <TextField
//             margin="dense"
//             label="Event Name"
//             fullWidth
//             value={formData.event_name}
//             error={!!formErrors.event_name}
//             helperText={formErrors.event_name}
//             onChange={(e) => setFormData({ ...formData, event_name: e.target.value })}
//           />
//           <TextField
//             margin="dense"
//             label="Start Date"
//             type="date"
//             fullWidth
//             value={formData.start_date}
//             error={!!formErrors.start_date}
//             helperText={formErrors.start_date}
//             onChange={(e) => setFormData({ ...formData, start_date: e.target.value })}
//             InputLabelProps={{ shrink: true }}
//           />
//           <TextField
//             margin="dense"
//             label="End Date"
//             type="date"
//             fullWidth
//             value={formData.end_date}
//             error={!!formErrors.end_date}
//             helperText={formErrors.end_date}
//             onChange={(e) => setFormData({ ...formData, end_date: e.target.value })}
//             InputLabelProps={{ shrink: true }}
//           />
//           <TextField
//             margin="dense"
//             label="Details Link"
//             fullWidth
//             value={formData.link}
//             error={!!formErrors.link}
//             helperText={formErrors.link}
//             onChange={(e) => setFormData({ ...formData, link: e.target.value })}
//           />
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setOpenFormDialog(false)}>Cancel</Button>
//           <Button onClick={handleFormSubmit} variant="contained" color="primary">
//             {isEditMode ? 'Update' : 'Add'}
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <Dialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)}>
//         <DialogTitle>Confirm Delete</DialogTitle>
//         <DialogContent>
//           Are you sure you want to delete this event?
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setDeleteDialogOpen(false)}>Cancel</Button>
//           <Button onClick={handleDelete} variant="contained" color="error">Delete</Button>
//         </DialogActions>
//       </Dialog>

//       <SnackBarComponent
//         open={snackbarOpen}
//         message={snackbarMessage}
//         severity={snackbarSeverity}
//         onClose={handleSnackbarClose}
//       />
//     </Box>
//   );
// };


import React, { useEffect, useState } from 'react';
import {
  Box, Typography, Button, Dialog, DialogActions,
  DialogContent, DialogTitle, TextField, IconButton,
  RadioGroup, FormControlLabel, Radio,
} from '@mui/material';
import { Delete, Edit } from '@mui/icons-material';
import TableComponent from '../../Components/TableComponent/TableComponent';
import { SnackBarComponent } from '../../Components/snackBar/snackBar';
import { LoadingSpinner } from '../../Components/spinner/spinner';
import { API_BASE_URL } from '../../config';
import api from '../../api/axiosInterceptor';
import axios from 'axios';

export const AdminCalendarEvents = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('info');

  const [openFormDialog, setOpenFormDialog] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);

  const [formData, setFormData] = useState({
    event_name: '',
    start_date: '',
    end_date: '',
    linkType: 'url', // 'url' or 'document'
    link: '',
  });
  const [selectedFile, setSelectedFile] = useState(null);
  const [formErrors, setFormErrors] = useState({});

  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deleteEvent, setDeleteEvent] = useState(null);

  const columns = [
    { id: 'slNo', field: 'slNo', headerName: 'Sl No.', width: 70 },
    { id: 'eventName', field: 'eventName', headerName: 'Event Name', width: 100 },
    { id: 'startDate', field: 'startDate', headerName: 'Start Time', width: 100 },
    { id: 'endDate', field: 'endDate', headerName: 'End Time', width: 100 },
    {
      id: 'detailsLink',
      field: 'detailsLink',
      headerName: 'Details',
      width: 120,
      renderCell: (params) => (
        params.row.linkType === 'url' ? (
          <a href={params.value} target="_blank" rel="noopener noreferrer">
            View Details
          </a>
        ) : params.value ? (
          <a href={params.value} download>
             View Details
          </a>
        ) : (
          'No Document'
        )
      ),
    },
    {
      id: 'actions',
      field: 'actions',
      headerName: 'Actions',
      width: 150,
      renderCell: (params) => (
        <>
          <IconButton color="primary" onClick={() => handleEdit(params.row)}>
            <Edit />
          </IconButton>
          <IconButton color="error" onClick={() => handleDeleteConfirmation(params.row)}>
            <Delete />
          </IconButton>
        </>
      ),
    },
  ];

  useEffect(() => {
    fetchEvents();
  }, []);

  const fetchEvents = () => {
    setLoading(true);
    axios.get(`${API_BASE_URL}/home-notification/calender-event/`)
      .then(response => {
        const apiData = response.data.map((item, index) => ({
          id: item.id,
          slNo: index + 1,
          eventName: item.event_name,
          startDate: item.start_date,
          endDate: item.end_date,
          detailsLink: item.link,
          linkType: item.link.endsWith('.pdf') || item.link.endsWith('.doc') ? 'document' : 'url',
        }));
        setRows(apiData);
        setLoading(false);
      })
      .catch(error => {
        console.error('Failed to fetch calendar events:', error);
        setSnackbarMessage('Failed to load calendar events.');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
        setLoading(false);
      });
  };

  const handleSnackbarClose = () => setSnackbarOpen(false);

  const handleAddEvent = () => {
    setIsEditMode(false);
    setFormData({ event_name: '', start_date: '', end_date: '', linkType: 'url', link: '' });
    setSelectedFile(null);
    setFormErrors({});
    setOpenFormDialog(true);
  };

  const handleEdit = (event) => {
    setIsEditMode(true);
    setSelectedEvent(event);
    setFormData({
      event_name: event.eventName,
      start_date: event.startDate || '',
      end_date: event.endDate || '',
      linkType: event.linkType || 'url',
      link: event.detailsLink || '',
    });
    setSelectedFile(null);
    setFormErrors({});
    setOpenFormDialog(true);
  };

  const handleDeleteConfirmation = (event) => {
    setDeleteEvent(event);
    setDeleteDialogOpen(true);
  };

  const handleDelete = () => {
    api.delete(`/home-notification/calender-event/${deleteEvent.id}/`)
      .then(() => {
        setSnackbarMessage('Calendar event deleted successfully.');
        setSnackbarSeverity('success');
        setSnackbarOpen(true);
        fetchEvents();
      })
      .catch(error => {
        console.error('Delete failed:', error);
        setSnackbarMessage('Failed to delete calendar event.');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
      })
      .finally(() => {
        setDeleteDialogOpen(false);
        setDeleteEvent(null);
      });
  };

  const validateForm = () => {
    const errors = {};
    if (!formData.event_name?.trim()) errors.event_name = 'Event name is required';
    // start_date and end_date are optional, so no validation here
    if (formData.linkType === 'url') {
      if (!formData.link?.trim()) errors.link = 'Details link is required';
      else if (!/^https?:\/\/.+\..+/.test(formData.link)) errors.link = 'Invalid link format';
    } else if (formData.linkType === 'document') {
      if (!selectedFile && !isEditMode) errors.link = 'Document file is required';
      if (selectedFile && selectedFile.size > 2 * 1024 * 1024) errors.link = 'File size must be less than 2MB';
    }
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file && file.size > 2 * 1024 * 1024) {
      setFormErrors((prev) => ({ ...prev, link: 'File size must be less than 2MB' }));
      setSelectedFile(null);
    } else {
      setFormErrors((prev) => ({ ...prev, link: null }));
      setSelectedFile(file);
    }
  };

  const handleFormSubmit = () => {
    if (!validateForm()) return;

    if (isEditMode) {
      if (formData.linkType === 'document') {
        const form = new FormData();
        form.append('event_name', formData.event_name);
        form.append('start_date', formData.start_date);
        form.append('end_date', formData.end_date);
        if (selectedFile) form.append('link', selectedFile);
        else form.append('link', formData.link); // keep existing
        form.append('linkType', 'document');

        api.patch(`/home-notification/calender-event/${selectedEvent.id}/`, form, {
          headers: { 'Content-Type': 'multipart/form-data' },
        })
          .then(() => {
            setSnackbarMessage('Calendar event updated successfully.');
            setSnackbarSeverity('success');
            setSnackbarOpen(true);
            fetchEvents();
          })
          .catch(error => {
            console.error('Update failed:', error);
            setSnackbarMessage('Failed to update calendar event.');
            setSnackbarSeverity('error');
            setSnackbarOpen(true);
          })
          .finally(() => setOpenFormDialog(false));
      } else {
        // url type update
        api.patch(`/home-notification/calender-event/${selectedEvent.id}/`, formData)
          .then(() => {
            setSnackbarMessage('Calendar event updated successfully.');
            setSnackbarSeverity('success');
            setSnackbarOpen(true);
            fetchEvents();
          })
          .catch(error => {
            console.error('Update failed:', error);
            setSnackbarMessage('Failed to update calendar event.');
            setSnackbarSeverity('error');
            setSnackbarOpen(true);
          })
          .finally(() => setOpenFormDialog(false));
      }
    } else {
      if (formData.linkType === 'document') {
        const form = new FormData();
        form.append('event_name', formData.event_name);
        form.append('start_date', formData.start_date);
        form.append('end_date', formData.end_date);
        if (selectedFile) form.append('link', selectedFile);
        form.append('linkType', 'document');

        api.post(`/home-notification/calender-event/`, form, {
          headers: { 'Content-Type': 'multipart/form-data' },
        })
          .then(() => {
            setSnackbarMessage('Calendar event added successfully.');
            setSnackbarSeverity('success');
            setSnackbarOpen(true);
            fetchEvents();
          })
          .catch(error => {
            console.error('Add failed:', error);
            setSnackbarMessage('Failed to add calendar event.');
            setSnackbarSeverity('error');
            setSnackbarOpen(true);
          })
          .finally(() => setOpenFormDialog(false));
      } else {
        // url type add
        api.post(`/home-notification/calender-event/`, formData)
          .then(() => {
            setSnackbarMessage('Calendar event added successfully.');
            setSnackbarSeverity('success');
            setSnackbarOpen(true);
            fetchEvents();
          })
          .catch(error => {
            console.error('Add failed:', error);
            setSnackbarMessage('Failed to add calendar event.');
            setSnackbarSeverity('error');
            setSnackbarOpen(true);
          })
          .finally(() => setOpenFormDialog(false));
      }
    }
  };

  if (loading) {
    return <LoadingSpinner size={30} />;
  }

  return (
    <Box sx={{ width: '100%', mt: 8, mb: 1, borderRadius: 2, boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)', backgroundColor: '#fff' }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" backgroundColor="rgba(195, 234, 203, 0.1)" p={2}>
        <Typography variant="h4" component="h1" sx={{ fontWeight: 'bold' }}>
          Admin Calendar Events
        </Typography>
        <Button variant="contained" color="primary" onClick={handleAddEvent}>
          Add Event
        </Button>
      </Box>

      <TableComponent
        columns={columns}
        rows={rows}
        manageColumnStatus
        enableSort={true}
        sx={{
          '& .MuiDataGrid-columnHeaders': {
            backgroundColor: '#1976d2',
            color: '#fff',
            fontWeight: 'bold',
          },
        }}
      />

      <Dialog open={openFormDialog} onClose={() => setOpenFormDialog(false)}>
        <DialogTitle>{isEditMode ? 'Edit Event' : 'Add Event'}</DialogTitle>
        <DialogContent>
          <TextField
            margin="dense"
            label="Event Name"
            fullWidth
            value={formData.event_name}
            error={!!formErrors.event_name}
            helperText={formErrors.event_name}
            onChange={(e) => setFormData({ ...formData, event_name: e.target.value })}
          />
          <TextField
            margin="dense"
            label="Start Date"
            type="date"
            fullWidth
            value={formData.start_date}
            error={!!formErrors.start_date}
            helperText={formErrors.start_date}
            onChange={(e) => setFormData({ ...formData, start_date: e.target.value })}
            InputLabelProps={{ shrink: true }}
          />
          <TextField
            margin="dense"
            label="End Date"
            type="date"
            fullWidth
            value={formData.end_date}
            error={!!formErrors.end_date}
            helperText={formErrors.end_date}
            onChange={(e) => setFormData({ ...formData, end_date: e.target.value })}
            InputLabelProps={{ shrink: true }}
          />

          <RadioGroup
            row
            value={formData.linkType}
            onChange={(e) => {
              setFormData({ ...formData, linkType: e.target.value, link: '' });
              setSelectedFile(null);
              setFormErrors((prev) => ({ ...prev, link: null }));
            }}
          >
            <FormControlLabel value="url" control={<Radio />} label="URL" />
            <FormControlLabel value="document" control={<Radio />} label="Document" />
          </RadioGroup>

          {formData.linkType === 'url' ? (
            <TextField
              margin="dense"
              label="Details Link (URL)"
              fullWidth
              value={formData.link}
              error={!!formErrors.link}
              helperText={formErrors.link}
              onChange={(e) => setFormData({ ...formData, link: e.target.value })}
            />
          ) : (
            <>
              <input
                accept="*"
                style={{ display: 'block', marginTop: '8px' }}
                id="file-upload"
                type="file"
                onChange={handleFileChange}
              />
              {formErrors.link && (
                <Typography variant="body2" color="error">
                  {formErrors.link}
                </Typography>
              )}
              {isEditMode && !selectedFile && formData.link && (
                <Typography variant="body2" sx={{ mt: 1 }}>
                  Current Document:{' '}
                  <a href={formData.link} target="_blank" rel="noopener noreferrer" download>
                    Download
                  </a>
                </Typography>
              )}
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenFormDialog(false)}>Cancel</Button>
          <Button onClick={handleFormSubmit} variant="contained" color="primary">
            {isEditMode ? 'Update' : 'Add'}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)}>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>
          Are you sure you want to delete this event?
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteDialogOpen(false)}>Cancel</Button>
          <Button onClick={handleDelete} variant="contained" color="error">Delete</Button>
        </DialogActions>
      </Dialog>

      <SnackBarComponent
        open={snackbarOpen}
        message={snackbarMessage}
        severity={snackbarSeverity}
        onClose={handleSnackbarClose}
      />
    </Box>
  );
};
